import "./i18n";
import React, { useCallback } from "react";
import copy from "copy-to-clipboard";
import styles from "./TextInputWithCopy.module.scss";
import { TextInput } from "../BaseElements/TextInput";
import type { BaseTextInputProps } from "@whatslly/types/UI-V2/BaseElements/TextInputType";
import { SvgV2 } from "../BaseElements/SvgV2";
import { modalService } from "@whatslly/ui-components/modals";
import Toast from "@whatslly/ui-components/v2/Toaster/Toast";
import { useTranslation } from "react-i18next";

export const TextInputWithCopy: React.FC<BaseTextInputProps> = (props) => {
  const { t } = useTranslation();
  const onCopy = useCallback(() => {
    copy(props.value?.toString() ?? "");
    modalService.openModal(Toast, { text: t("copy_to_clipboard") });
  }, [props.value]);

  return (
    <div className={styles.inputWithCopy}>
      <TextInput {...props} containerClassName={styles.input} />
      <div className={styles.copy} onClick={onCopy}>
        <SvgV2 iconName={`copy-text-icon`} />
      </div>
    </div>
  );
};
